import { Component, Inject, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

import { AuthService } from 'src/app/core/services/auth.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-auth-modal',
  templateUrl: './auth-modal.component.html',
  styleUrls: ['./auth-modal.component.scss']
})
export class AuthModalComponent implements OnInit, OnDestroy {
  @Input() isMobile = false;
  @Input() isSignup = false;
  loginForm: FormGroup;
  submitted = false;
  returnUrl: string;
  error = '';
  accessCode = '';
  hide = true;
  subscriptionRef: Subscription;
  code = '9176267475';
  constructor(public authService: AuthService, private formBuilder: FormBuilder, private userService: UserService,
    private router: Router, @Optional() private dialogRef: MatDialogRef<AuthModalComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any, @Inject(MAT_BOTTOM_SHEET_DATA) public bottomData: any, private spinner: NgxSpinnerService, private bottomSheetRef: MatBottomSheetRef<AuthModalComponent>) { }


  ngOnInit(): void {
    this.authService.currentUserSubject.pipe(take(1)).subscribe(data => {
      if (data) {
        console.log('Auth modal');
      }
    });
    if (this.data) {
      this.isSignup = this.data?.isSignup ?? this.isSignup;
      this.isMobile = this.data?.isMobile ?? this.isMobile;
    } else {
      this.isSignup = this.bottomData?.isSignup ?? this.isSignup;
      this.isMobile = this.bottomData?.isMobile ?? this.isMobile;
    }
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });

  }
  get f() {
    return this.loginForm.controls;
  }
  onSubmitLogin() {
    this.submitted = true;
    this.error = '';
    if (this.accessCode.length == 0 || this.accessCode != this.code) {
      this.error = 'Invalid access code';
      return;
    }
    this.spinner.show("authSpinner");
    this.userService.checkUserEmailExistsObservable(this.f.email.value).subscribe(data => {
      if (data && data?.length == 0) {
        this.authService.createNewAuthUser(this.f.email.value, this.f.password.value).then(
          (res) => {
            if (res) {
              this.spinner.hide("authSpinner");
              this.dialogRef.close();
              this.router.navigate(['/authentication/onboarding']);
            }
          }).catch(e => {
            console.log(e);
            if (e.code === 'auth/email-already-in-use') {
              this.loginEmailUser(this.f.email.value, this.f.password.value);
              this.dialogRef.close();
            } else {
              this.error = e.message;
              alert('line 79')
              alert(e);
            }
            this.spinner.hide("authSpinner");
          });
      } else {
        this.loginEmailUser(this.f.email.value, this.f.password.value);
      }
    });
  }

  loginEmailUser(email: string, pass: string) {

    this.authService
      .login(email, pass).catch(e => {
        this.error = e.message;
        alert('line 95')
        alert(e);
      });

    this.subscriptionRef = this.authService.currentUserSubject.pipe(
      take(2),
    ).subscribe({
      next: data => {
        this.spinner.hide("authSpinner");
        if (data && data != null && this.dialogRef != null) {
          this.dialogRef.close({ onboardingCompleted: data.onboardingCompleted, isInstructor: data.isInstructor });
        } else if (data && data != null) {
          this.bottomSheetRef.dismiss({ onboardingCompleted: data.onboardingCompleted, isInstructor: data.isInstructor });
        }
      },
      error: error => {
        this.spinner.hide("authSpinner");
        this.error = error;
        this.submitted = false;
        alert('line 114')
        alert(error);
      }
    });
  }

  async submitFacebook() {
    this.error = '';
    if (this.accessCode.length == 0 || this.accessCode != this.code) {
      this.error = 'Invalid access code';
      return;
    }
    const result = await this.authService.facebookAuth();
    if (result !== true && result?.error) {
      alert('line 128')
      alert(result);
      this.error = result.console.error();
    }
    this.dialogRef.close();
  }

  async submitGoogle() {
    this.error = '';
    if (this.accessCode.length == 0 || this.accessCode != this.code) {
      this.error = 'Invalid access code';
      return;
    }
    const result = await this.authService.googleAuth();
    if (result !== true && result?.error) {
      this.error = result.console.error();
      alert('line 144')
      alert(result);
    }
    this.dialogRef.close();
  }

  closeBottomSheet() {
    this.bottomSheetRef.dismiss();
  }
  closeDialog() {
    this.dialogRef.close();
  }
  ngOnDestroy(): void {
    this.subscriptionRef?.unsubscribe();
  }
}
